import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "checkbox"
};
const _hoisted_2 = {
    key: 0,
    class: "is-hidden-block is-indent"
};
const _hoisted_3 = { class: "checkbox" };
const _hoisted_4 = { class: "checkbox" };
const _hoisted_5 = {
    key: 0,
    class: "checkbox"
};
const _hoisted_6 = { class: "checkbox" };
import _ from "lodash";
import BigNumber from "bignumber.js";
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import i18n from "@/localization/localization.js";
import AuIcon from "@/components/extended/AuIcon.vue";
import isFieldVisible from "@/help/typesProjects";
import UForm from "@/components/uikit/uComponents/uForm/UForm.vue";
import UInput from "@/components/uikit/uComponents/UInput.vue";
import URow from "@/components/uikit/uLayouts/URow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectFormFirstStepV2',
    props: {
        id: {},
        firstPartOfProjectInfo: {}
    },
    emits: ["firstPartOfProject", "nextStep"],
    setup(__props, { emit: __emit }) {
        const t = (key) => i18n.global.t(key);
        const props = __props;
        const emit = __emit;
        const store = useStore();
        // Состояние
        const showExtended = ref(false);
        const platforms = ref([]);
        const projectDescriptionEng = ref("");
        const loading = ref(false);
        // Вычисляемые свойства из Vuex
        const countrys = computed(() => store.getters.country);
        const language = computed(() => store.getters.language);
        const companies = computed(() => store.getters.companies);
        const requestsToIssue = computed(() => store.getters.requestsToIssue);
        const defaultAutMnemonic = computed(() => store.getters["defaultToken/defaultAutMnemonic"]);
        const isTestRole = computed(() => store.getters["profile/isTestRole"]);
        const smartContractsTypes = computed(() => store.getters.smartContractsTypes);
        const apiSystemSettings = computed(() => store.getters.apiSystemSettings);
        // Опции для селектов
        const countryOptions = computed(() => _.map(countrys.value, c => ({ display: c.name, value: c.code })));
        const companiesOptions = computed(() => {
            const options = _.map(companies.value, (company) => ({
                display: language.value === "ru" ? company.nameRus : company.nameEng,
                value: `/api/companies/${company.id}`
            }));
            return _.sortBy(options, "display");
        });
        const platformOptions = computed(() => platforms.value.map((platform) => ({
            display: platform.name,
            value: `/api/external_platforms/${platform.id}`
        })));
        const applicationTypeOptions = computed(() => [
            { display: language.value == "ru" ? "Общий" : "Common", value: "common" },
            { display: language.value == "ru" ? "Доход (аренда)" : "Income (Rent)", value: "income" },
            { display: language.value == "ru" ? "Рост капитала" : "Capital Growth", value: "growth" },
            { display: language.value == "ru" ? "Контроль рисков" : "Risk Control", value: "risk" },
            { display: language.value == "ru" ? "Пул" : "Pool", value: "pool" },
            { display: language.value == "ru" ? "Пул ставок" : "Staking pool", value: "stakingPool" },
            { display: language.value == "ru" ? "Основной" : "Foundation", value: "foundation" }
        ]);
        const userLevelOptions = computed(() => Object.values(apiSystemSettings.value?.userLimitStatuses || {}).map(level => ({
            display: level.charAt(0).toUpperCase() + level.slice(1).toLowerCase(),
            value: level
        })));
        const riskOptions = computed(() => [
            { display: language.value == "ru" ? "Консервативный" : "Conservative", value: "conservative" },
            { display: language.value == "ru" ? "Сбалансированный" : "Balanced", value: "balanced" },
            { display: language.value == "ru" ? "Агрессивный" : "Agressive", value: "agressive" }
        ]);
        const prepareSmartContractsTypes = computed(() => {
            const options = smartContractsTypes.value.map((item) => ({
                display: getTranslatedTitle(item.title),
                value: item.type
            }));
            return _.sortBy(options, "display");
        });
        // Режим (создание/редактирование)
        const mode = computed(() => props.id === "new"
            ? t("projects.form.firstStep.labelNew")
            : t("projects.form.firstStep.labelEdit"));
        // Начальные значения формы
        const initialFormValues = computed(() => {
            if (props.firstPartOfProjectInfo) {
                return {
                    realEstateType: props.firstPartOfProjectInfo.realEstateType,
                    country: props.firstPartOfProjectInfo.country,
                    district: props.firstPartOfProjectInfo.district,
                    city: props.firstPartOfProjectInfo.city,
                    street: props.firstPartOfProjectInfo.street,
                    developer: props.firstPartOfProjectInfo.developer,
                    tourUrl: props.firstPartOfProjectInfo.tourUrl,
                    totalAreaMt: props.firstPartOfProjectInfo.totalAreaMt,
                    totalAreaFt: props.firstPartOfProjectInfo.totalAreaFt,
                    projectNameEng: props.firstPartOfProjectInfo.projectNameEng,
                    address: props.firstPartOfProjectInfo.address,
                    projectAbbrNameEng: props.firstPartOfProjectInfo.projectAbbrNameEng,
                    shortDescription: props.firstPartOfProjectInfo.shortDescription,
                    tokensCount: props.firstPartOfProjectInfo.tokensCount,
                    company: props.firstPartOfProjectInfo.company,
                    externalPlatform: props.firstPartOfProjectInfo.externalPlatform,
                    applicationType: props.firstPartOfProjectInfo.applicationType || applicationTypeOptions.value[0],
                    hasOpenSale: props.firstPartOfProjectInfo.hasOpenSale || false,
                    requiredUserStatus: props.firstPartOfProjectInfo.requiredUserStatus || "base",
                    risk: props.firstPartOfProjectInfo.risk,
                    projectType: props.firstPartOfProjectInfo.projectType,
                    cryptoActiveType: props.firstPartOfProjectInfo.cryptoActiveType,
                    burnUnsoldTokens: props.firstPartOfProjectInfo.burnUnsoldTokens,
                    autodeployTokens: props.firstPartOfProjectInfo.autodeployTokens,
                    makeVisible: !props.firstPartOfProjectInfo.makeVisible,
                    hasEscrow: props.firstPartOfProjectInfo.hasEscrow,
                    minExpertVotes: props.firstPartOfProjectInfo.minExpertVotes || "",
                    issuerCommision: props.firstPartOfProjectInfo.issuerCommision || "",
                    investType: props.firstPartOfProjectInfo.investType,
                    isVoiting: props.firstPartOfProjectInfo.isVoiting
                };
            }
            return {
                realEstateType: null,
                country: null,
                district: null,
                city: null,
                street: null,
                developer: null,
                tourUrl: null,
                totalAreaMt: null,
                totalAreaFt: null,
                projectNameEng: null,
                address: null,
                projectAbbrNameEng: null,
                shortDescription: "",
                tokensCount: "",
                company: null,
                externalPlatform: null,
                applicationType: applicationTypeOptions.value[0].value,
                hasOpenSale: false,
                requiredUserStatus: apiSystemSettings.value?.userLimitStatuses?.[0] || "base",
                risk: "",
                projectType: "invest_v2",
                cryptoActiveType: "investment",
                burnUnsoldTokens: true,
                autodeployTokens: process.env.VUE_APP_AUTODEPLOY_PROJECT == "true",
                makeVisible: isTestRole.value,
                hasEscrow: false,
                minExpertVotes: "",
                issuerCommision: "",
                investType: "non-redeemable",
                isVoiting: false
            };
        });
        // Валидаторы
        const validateProjectName = (value) => {
            const regexStartWithLetter = /^[a-zA-Z]+.*$/;
            if (!value?.match(regexStartWithLetter)) {
                return "The name must start with a latin letter";
            }
            return true;
        };
        const validateProjectAbbr = (value) => {
            const regexStartWithLetter = /^[a-zA-Z]+.*$/;
            if (!value?.match(regexStartWithLetter)) {
                return "The token symbol / mnemonic must start with a latin letter";
            }
            const regexContainLatin = /^[a-zA-Z]+[a-zA-Z\d ]*$/;
            if (!value?.match(regexContainLatin)) {
                return "The token symbol / mnemonic must contain only latin characters and numbers";
            }
            return true;
        };
        const validateTokensCount = (value) => {
            if (!BigNumber(value).isInteger()) {
                return t("projects.form.firstStep.errorTokenCountNoInteger");
            }
            return true;
        };
        // Методы
        const uppercaseAbbr = (value) => {
            return value?.toUpperCase();
        };
        function getTranslatedTitle(title) {
            switch (title) {
                case "Голосующий":
                    return t("projects.projectTypes.voting");
                case "Mudaraba":
                    return t("projects.projectTypes.mudaraba");
                case "Musharaka":
                    return t("projects.projectTypes.musharaka");
                case "Инвестиционный":
                    return t("projects.projectTypes.invest");
                default:
                    return title;
            }
        }
        const nextStep = (values) => {
            console.log(values);
            const firstPartOfProjectInfo = {
                ...values,
                projectDescriptionRus: values.projectDescriptionEng.value,
                makeVisible: values.makeVisible ? false : true
            };
            emit("firstPartOfProject", firstPartOfProjectInfo);
            emit("nextStep");
        };
        // Загрузка данных
        const loadPlatforms = async () => {
            const params = {
                page: 1,
                itemsPerPage: 30,
                status: "success"
            };
            try {
                const resp = await store.dispatch("platforms/getPlatforms", params);
                platforms.value = resp.data;
            }
            catch (error) {
                // Обработка ошибки
            }
        };
        // Следим за companies для авто-выбора
        watch(companies, () => {
            const options = companiesOptions.value;
            if (options.length === 1 && !initialFormValues.value.company) {
                // Здесь нужно обновить форму
            }
        });
        // Инициализация
        onMounted(async () => {
            if (_.isEmpty(countrys.value)) {
                await store.dispatch("getCountry");
            }
            if (_.isEmpty(companies.value)) {
                await store.dispatch("getCompanies");
            }
            if (_.isEmpty(requestsToIssue.value)) {
                await store.dispatch("getHydraRequestToIssue");
            }
            await loadPlatforms();
            if (props.id !== "new" && !props.firstPartOfProjectInfo) {
                const project = requestsToIssue.value.find((item) => item.id == props.id);
                if (project) {
                    projectDescriptionEng.value = project.descriptionCapitalEng;
                }
            }
            if (props.firstPartOfProjectInfo) {
                projectDescriptionEng.value = props.firstPartOfProjectInfo.projectDescriptionEng;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(UForm, {
                "initial-values": initialFormValues.value,
                loading: loading.value,
                "submit-button-text": "Next",
                onSubmitForm: nextStep
            }, {
                header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(t("projects.form.firstStep.labelFirstPart")) + " " + _toDisplayString(mode.value) + " " + _toDisplayString(t("projects.form.firstStep.labelLastPart")), 1)
                ]),
                default: _withCtx(() => [
                    _createVNode(UInput, {
                        name: "projectType",
                        label: t('projects.form.firstStep.projectType'),
                        placeholder: t('projects.form.firstStep.projectTypePlaceholder'),
                        type: "select",
                        tooltip: `Voting project used to collect ${defaultAutMnemonic.value} as vote weight to determine which project is preferable for furter investment. After completion or decline vote fund will be returned to investor back.`,
                        options: prepareSmartContractsTypes.value,
                        required: ""
                    }, null, 8, ["label", "placeholder", "tooltip", "options"]),
                    _createVNode(URow, null, {
                        default: _withCtx(() => [
                            _createVNode(UInput, {
                                name: "projectNameEng",
                                label: t('projects.form.firstStep.projectNameLabel'),
                                placeholder: t('projects.form.firstStep.projectNamePlaceholder'),
                                tooltip: "The short name of your project. (at least 10 characters)",
                                required: "",
                                "custom-rule": validateProjectName
                            }, null, 8, ["label", "placeholder"]),
                            _createVNode(UInput, {
                                name: "projectAbbrNameEng",
                                label: t('projects.form.firstStep.projectAbbrNameLabel'),
                                placeholder: t('projects.form.firstStep.projectAbbrNamePlaceholder'),
                                maxlength: 8,
                                required: "",
                                "custom-rule": validateProjectAbbr,
                                "intermediate-handler": uppercaseAbbr
                            }, null, 8, ["label", "placeholder"])
                        ]),
                        _: 1
                    }),
                    _createVNode(UInput, {
                        name: "country",
                        label: t('Country'),
                        placeholder: t('companies.form.countryPlaceholder') + '(*)',
                        type: "select",
                        options: countryOptions.value,
                        required: ""
                    }, null, 8, ["label", "placeholder", "options"]),
                    _createVNode(URow, null, {
                        default: _withCtx(() => [
                            _createVNode(UInput, {
                                name: "realEstateType",
                                label: t('Real estate type'),
                                placeholder: t('Short description')
                            }, null, 8, ["label", "placeholder"]),
                            _createVNode(UInput, {
                                name: "district",
                                label: t('District'),
                                placeholder: t('Enter district')
                            }, null, 8, ["label", "placeholder"])
                        ]),
                        _: 1
                    }),
                    _createVNode(URow, null, {
                        default: _withCtx(() => [
                            _createVNode(UInput, {
                                name: "city",
                                label: t('City'),
                                placeholder: t('Enter city')
                            }, null, 8, ["label", "placeholder"]),
                            _createVNode(UInput, {
                                name: "street",
                                label: t('Street'),
                                placeholder: t('Enter street')
                            }, null, 8, ["label", "placeholder"])
                        ]),
                        _: 1
                    }),
                    _createVNode(URow, null, {
                        default: _withCtx(() => [
                            _createVNode(UInput, {
                                name: "developer",
                                label: t('Developer'),
                                placeholder: t('Enter developer')
                            }, null, 8, ["label", "placeholder"]),
                            _createVNode(UInput, {
                                name: "tourUrl",
                                label: t('Tour url'),
                                placeholder: t('Enter tour url')
                            }, null, 8, ["label", "placeholder"])
                        ]),
                        _: 1
                    }),
                    _createVNode(URow, null, {
                        default: _withCtx(() => [
                            _createVNode(UInput, {
                                name: "totalAreaMt",
                                label: t('Total area sq.m.'),
                                placeholder: t('Enter total area in meters'),
                                type: "number"
                            }, null, 8, ["label", "placeholder"]),
                            _createVNode(UInput, {
                                name: "totalAreaFt",
                                label: t('Total area ft.'),
                                placeholder: t('Enter total area in feet'),
                                type: "number"
                            }, null, 8, ["label", "placeholder"])
                        ]),
                        _: 1
                    }),
                    _createVNode(UInput, {
                        name: "shortDescription",
                        label: t('projects.form.firstStep.shortDescriptionLabel'),
                        placeholder: t('projects.form.firstStep.shortDescriptionPlaceholder'),
                        type: "textarea"
                    }, null, 8, ["label", "placeholder"]),
                    _createVNode(UInput, {
                        name: "projectDescriptionEng",
                        label: t('projects.form.firstStep.projectDescLabel'),
                        placeholder: t('projects.form.firstStep.projectDescEngPlaceholder'),
                        type: "editor",
                        required: ""
                    }, null, 8, ["label", "placeholder"]),
                    _createVNode(UInput, {
                        name: "address",
                        label: t('projects.form.firstStep.projectEntityAddress'),
                        placeholder: t('projects.form.firstStep.projectEntityAddress'),
                        tooltip: t('projects.form.firstStep.projectEntityAddressTooltip')
                    }, null, 8, ["label", "placeholder", "tooltip"]),
                    _createVNode(UInput, {
                        name: "tokensCount",
                        label: t('projects.form.firstStep.projectTokensCountLabel'),
                        placeholder: t('projects.form.firstStep.projectTokensCountPlaceholder'),
                        type: "number",
                        required: "",
                        "custom-rule": validateTokensCount
                    }, null, 8, ["label", "placeholder"]),
                    _createVNode(UInput, {
                        name: "company",
                        placeholder: t('projects.form.firstStep.projectCompanyPlaceholder'),
                        type: "select",
                        options: companiesOptions.value,
                        label: t('projects.form.firstStep.projectCompanyLabel'),
                        required: ""
                    }, null, 8, ["placeholder", "options", "label"]),
                    (isTestRole.value)
                        ? (_openBlock(), _createBlock(UInput, {
                            key: 0,
                            name: "externalPlatform",
                            placeholder: t('projects.form.firstStep.projectPlatformPlaceholder'),
                            type: "select",
                            options: platformOptions.value,
                            label: t('projects.form.firstStep.projectPlatformLabel'),
                            tooltip: t('projects.form.firstStep.projectPlatformTooltip')
                        }, null, 8, ["placeholder", "options", "label", "tooltip"]))
                        : _createCommentVNode("", true),
                    _createVNode(UInput, {
                        name: "applicationType",
                        placeholder: t('projects.form.firstStep.projectApplicationTypePlaceholder'),
                        type: "select",
                        label: t('projects.form.firstStep.applicationType'),
                        options: applicationTypeOptions.value
                    }, null, 8, ["placeholder", "label", "options"]),
                    (initialFormValues.value.projectType === 'invest' || initialFormValues.value.projectType === 'invest_v2')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(UInput, {
                                name: "hasOpenSale",
                                type: "boolean",
                                label: t('projects.form.firstStep.hasOpenSale')
                            }, null, 8, ["label"])
                        ]))
                        : _createCommentVNode("", true),
                    (apiSystemSettings.value?.enableUserLevels == '1')
                        ? (_openBlock(), _createBlock(UInput, {
                            key: 2,
                            name: "requiredUserStatus",
                            placeholder: t('projects.form.firstStep.minUserLevelPlaceholder'),
                            type: "select",
                            label: t('projects.form.firstStep.minUserLevel'),
                            options: userLevelOptions.value
                        }, null, 8, ["placeholder", "label", "options"]))
                        : _createCommentVNode("", true),
                    (initialFormValues.value.applicationType == 'pool')
                        ? (_openBlock(), _createBlock(UInput, {
                            key: 3,
                            name: "risk",
                            placeholder: t('projects.form.firstStep.projectRiskTypePlaceholder'),
                            type: "select",
                            label: t('projects.form.firstStep.riskType'),
                            options: riskOptions.value
                        }, null, 8, ["placeholder", "label", "options"]))
                        : _createCommentVNode("", true),
                    (isTestRole.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createElementVNode("div", {
                                class: "is-indent is-extended",
                                onClick: _cache[0] || (_cache[0] = ($event) => (showExtended.value = !showExtended.value))
                            }, [
                                _createElementVNode("span", null, _toDisplayString(t("projects.form.firstStep.projectExtended")), 1),
                                _createVNode(AuIcon, {
                                    icon: showExtended.value ? 'chevron_up' : 'chevron_down',
                                    clickable: ""
                                }, null, 8, ["icon"])
                            ]),
                            (showExtended.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(URow, null, {
                                        default: _withCtx(() => [
                                            (_unref(isFieldVisible)('minExpertVotes', initialFormValues.value.projectType))
                                                ? (_openBlock(), _createBlock(UInput, {
                                                    key: 0,
                                                    name: "minExpertVotes",
                                                    label: t('projects.form.firstStep.minExpertVotes'),
                                                    placeholder: t('projects.form.firstStep.minExpertVotesPlaceholder'),
                                                    type: "number"
                                                }, null, 8, ["label", "placeholder"]))
                                                : _createCommentVNode("", true),
                                            (_unref(isFieldVisible)('issuerCommision', initialFormValues.value.projectType))
                                                ? (_openBlock(), _createBlock(UInput, {
                                                    key: 1,
                                                    name: "issuerCommision",
                                                    label: t('projects.form.firstStep.issuerCommision'),
                                                    placeholder: t('projects.form.firstStep.issuerCommisionPlaceholder'),
                                                    type: "number",
                                                    max: "100"
                                                }, null, 8, ["label", "placeholder"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode(UInput, {
                                            name: "burnUnsoldTokens",
                                            type: "boolean",
                                            label: t('projects.form.firstStep.projectBurnUnsoldTokens')
                                        }, null, 8, ["label"])
                                    ]),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode(UInput, {
                                            name: "autodeployTokens",
                                            type: "boolean",
                                            label: t('projects.form.firstStep.projectAutodeploy')
                                        }, null, 8, ["label"])
                                    ]),
                                    (_unref(isFieldVisible)('hasEscrow', initialFormValues.value.projectType))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            _createVNode(UInput, {
                                                name: "hasEscrow",
                                                type: "boolean",
                                                label: t('projects.form.firstStep.projectHasEscrow')
                                            }, null, 8, ["label"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(UInput, {
                                            name: "makeVisible",
                                            type: "boolean",
                                            label: t('projects.form.firstStep.projectMakeVisible')
                                        }, null, 8, ["label"])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["initial-values", "loading"]));
        };
    }
});
